import { ref } from 'vue';
import { fetchFeedPickerHtml } from '../services/feedPickerApi';
import { fetchOptionsByFields } from '../services/feedPickerOptionsApi';
import { sanitizeParams, normalizeForApi, ensureDefaultTasteAndBrands } from '../utils/feedPickerParams';

export function useFeedPicker() {
    const isSliderVisible = ref(true);
    const isLoading = ref(false);
    const error = ref(null);

    const currentRequestParams = ref({});
    const defaultFilters = ref({ brands: [], taste: [] });

    // доступные вкусы/бренды под текущую выдачу
    const availableOptions = ref({ taste: [], brand: [] });

    const requestHtml = async (rawParams) => {
        isLoading.value = true;
        error.value = null;

        try {
            let params = sanitizeParams(rawParams);
            params = normalizeForApi(params);

            const html = await fetchFeedPickerHtml(params);

            currentRequestParams.value = params;

            // после получения HTML выдачи получаем доступные опции фильтров
            // (важно: бэк просит special_needs[] только если юзер выбрал)
            try {
                const options = await fetchOptionsByFields({
                    fields: ['taste', 'brand'],
                    params,
                });

                availableOptions.value = {
                    taste: options?.taste || [],
                    brand: options?.brand || [],
                };
            } catch (e) {
                console.warn('[options] taste/brand failed', e);
                availableOptions.value = { taste: [], brand: [] };
            }

            return html;
        } catch (e) {
            error.value = 'Произошла ошибка. Попробуйте ещё раз';
            console.error(e);
            return null;
        } finally {
            isLoading.value = false;
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }
    };

    const startSearch = async (sliderParams) => {
        isSliderVisible.value = false;

        const paramsWithDefaults = ensureDefaultTasteAndBrands(sliderParams);
        const html = await requestHtml(paramsWithDefaults);

        if (html === null) return null;

        defaultFilters.value = {
            brands: currentRequestParams.value.brands ?? [],
            taste: currentRequestParams.value.taste ?? [],
        };

        return html;
    };

    const applyFilters = async (filtersFromComponent) => {
        // тут НЕ добавляем дефолты, иначе пользователь не сможет снять фильтры
        return await requestHtml({ ...currentRequestParams.value, ...filtersFromComponent });
    };

    return {
        isSliderVisible,
        isLoading,
        error,
        defaultFilters,
        currentRequestParams,
        availableOptions,
        startSearch,
        applyFilters,
    };
}
